/* istanbul ignore file */

import { UpdatePageLayout } from 'framework/ui/layout';
import { UpdateForm } from 'framework/form';
import VacancyPublicationForm from '../VacancyPublicationForm';
import VacancyPublicationEntityHeader from 'domain/recruiting/vacancy/publication/shared/VacancyPublicationEntityHeader';
import UpdateVacancyPublicationBreadcrumbs from './Breadcrumbs';
import { useVacancyGroupId, useVacancyGroupUrl } from '../../../../routing';
import useVacancyPublicationService from '../../vacancyPublicationService';
import { useParams } from 'react-router-dom';
import { VacancyPublicationDetailResponse, VacancyPublicationFormData, VacancyPublicationResponse } from '../../types';

const UpdateVacancyPublication = () => {
  const { update, getById, getValidationSchema } = useVacancyPublicationService();
  const groupId = useVacancyGroupId();
  const { publicationId } = useParams<Dictionary<string>>();

  const { getPublicationUrl } = useVacancyGroupUrl();

  const getDataFunc = async (id: string) => {
    const response = await getById(id);

    const mapOfficeToLocation = (location: { country?: string } | null) => {
      if (!location || !location.country) return null;

      const countryMapping: Record<string, number> = {
        US: 1,
        BY: 2,
        PL: 3,
        GE: 4,
      };

      return countryMapping[location.country] || 5;
    };

    const mapVacancyToDesiredFormat = (publication: VacancyPublicationResponse): VacancyPublicationFormData => {
      const publicationDetails = publication.publicationDetails ?? [];
      const publicationDetail: VacancyPublicationDetailResponse | null =
        publicationDetails.length > 0 ? publicationDetails[publicationDetails.length - 1] : null;

      return {
        id: publication.id,
        vacancyGroupId: publication.vacancyGroupId,
        vacancyGroupName: publication.vacancyGroupName,
        name: publication.name,
        type: publication.type,
        status: publication.status,
        description: publication.description,
        countryOfResidences: publication.countryOfResidences,
        englishLevels: publication.englishLevels,
        details: {
          id: publicationDetail?.id,
          contractType: publicationDetail?.contractType || [],
          location: publicationDetail?.location
            ? mapOfficeToLocation({ country: publicationDetail.location.country })
            : null,
          relocationOption: publicationDetail?.relocationOption,
        },
        formFields: (publication.formFields || []).map(field => {
          return {
            value: field.label || '',
            type: field.type,
            options: field.options || [],
          };
        }),
        createdAt: publication.createdAt,
        createdBy: publication.createdBy,
      };
    };

    return mapVacancyToDesiredFormat(response);
  };

  return (
    <UpdateForm
      submitFormFunc={(_, values) => update(publicationId!!, values)}
      getDataFunc={() => getDataFunc(publicationId!!)}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        redirect: getPublicationUrl(groupId, publicationId!!),
        message: 'You are awesome! The Vacancy Publication has been successfully saved.',
      }}
    >
      <UpdatePageLayout
        title="Edit: Vacancy Publication"
        breadcrumbs={<UpdateVacancyPublicationBreadcrumbs />}
        entityHeader={<VacancyPublicationEntityHeader />}
      >
        <VacancyPublicationForm />
      </UpdatePageLayout>
    </UpdateForm>
  );
};

export default UpdateVacancyPublication;
